<template>
  <div>
    <div class="right-nav-merged-type">
      <div class="middle">
        <div class="item" @click="myChat">
            <el-tooltip class="item" effect="light" content="在线客服" placement="left">
              <span class="wrap"><i class="icon el-icon-chat-dot-round"></i></span>
            </el-tooltip>
        </div>
        <div class="item" @click="myMessage">
          <el-tooltip class="item" effect="light" content="消息列表" placement="left">
            <span class="wrap"><i class="icon el-icon-message"></i></span>
          </el-tooltip>
        </div>
        <div class="item" @click="mycart">
          <el-tooltip class="item" effect="light" content="购物车" placement="left">
            <span class="wrap"><i class="icon el-icon-shopping-cart-2"></i></span>
          </el-tooltip>
        </div>
      </div>
      <div class="bottom">
        <div class="item" @click="suggest" >
          <el-tooltip class="item" effect="light" content="意见反馈" placement="left">
            <span class="wrap"><i class="icon el-icon-edit-outline"></i></span>
          </el-tooltip>
        </div>

        <div class="item" @click="toTop" >
          <el-tooltip class="item" effect="light" content="回到顶部" placement="left">
            <span class="wrap"><i class="icon el-icon-top"></i></span>
          </el-tooltip>
        </div>
      </div>
    </div>
    <suggest ref="suggest"></suggest>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import Cookie from 'js-cookie'
  import Suggest from '@/components/base/suggest.vue'

  export default {
    name: 'rightNav',
    components: {Suggest},
    methods: {
      ...mapMutations({
        setSearchObj: 'SET_SEARCHOBJ'
      }),
      myMessage(){
        if (Cookie.get('token')) {
          this.$router.push({path: '/message'})
        } else {
          this.$router.push({path: '/login?rtn=' + encodeURIComponent('/message')})
        }
      },
      myChat(){
        window.open("https://work.weixin.qq.com/kfid/kfc7c15a28803fb51bc", "_blank");
      },
      mycart(){
        if (Cookie.get('token')) {
          this.$router.push({path: '/shopping-trolley'})
        } else {
          this.$router.push({path: '/login?rtn=' + encodeURIComponent('/shopping-trolley')})
        }
      },
      toTop() {
        document.documentElement.scrollTop = 0
      },
      suggest(){
          this.$refs.suggest.show();
      }
    }
  }
</script>

<style scoped lang="scss">
  .icon {
    font-size: 18px;
    color: #333;
  }
  .right-nav-merged-type {
    z-index: 930;
    background: #fff;
    box-shadow: 0 0 6px 0 rgba(107,66,66,8%);
    width: 40px;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    .middle {
      position: absolute;
      top: 40%;
      left: 0;
    }
    .bottom {
      position: absolute;
      bottom: 40px;
      left: 0;
    }
    .item {
      display: block;
      height: 39px;
      .wrap {
        width: 20px;
        height: 30px;
        display: inline-block;
        padding-top: 9px;
        cursor: pointer;
        text-align: center;
        margin-left: 10px;
      }
    }
  }
  >>>.el-button--primary:hover {
    background: #004097;
    border-color: #004097;
    color: #FFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/rightNav.vue